export function getCollectionText(
	sourceArray: Array<any>,
	path: string = null,
	maxRenderCount: number = 3
) {
	return sourceArray && Array.isArray(sourceArray)
		? sourceArray
				.slice(0, maxRenderCount)
				.map(item => (typeof item === 'string' ? item : item[path]))
				.join(', ') + (sourceArray.length > 3 ? ', [..]' : '')
		: null;
}
